<div (click)="handleClick()" class="modal__article {{classList}}">
  <img class="article__image" src="{{image}}" alt="image of the article">
  <div class="article__container">
    <h3 class="article__title">{{title}}</h3>
    <p class="article__description">{{truncateString(description, 200, false) + '...'}}</p>
  </div>
</div>
